// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  display: flex;
  align-items: center;
  background-color: rgb(217, 213, 201);
  border-top: solid 1px rgb(180, 173, 161);
  border-bottom: solid 1px rgb(180, 173, 161);
  padding: 0;
  position: sticky;
  top: 98px;
  left: 0;
  right: 0;
  z-index: 10;
  overflow: hidden;
}

nav ul {
  overflow-x: auto;
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  white-space: nowrap;
  overflow-x: auto;
  flex-grow: 1;
}

nav ul::-webkit-scrollbar {
  display: none;
}

nav ul li {
  display: inline-block;
  padding: 10px;
}

nav ul li.active {
  background-color: rgb(122,148,90);
  border-radius: 5px;
}

nav ul li.active a {
  color: white;
}

nav ul li:hover {
  opacity: .8;
}

nav ul li a {
  text-decoration: none;
  color: rgb(49, 47, 48);
  font-size: 16px;
}

nav ul li a.active {
  color: white;
}

.scroll-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 10px;
  color: rgb(49, 47, 48);
}

.scroll-button:focus {
  outline: none;
}

.scroll-button.left {
  margin-right: 10px;
}

.scroll-button.right {
  margin-left: 10px;
}

@media screen and (max-width: 910px) {
  nav {
    top: 83px;
  }
}

@media screen and (max-width: 520px) {
  nav {
    top: 67px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,wCAAwC;EACxC,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":["nav {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: rgb(217, 213, 201);\r\n  border-top: solid 1px rgb(180, 173, 161);\r\n  border-bottom: solid 1px rgb(180, 173, 161);\r\n  padding: 0;\r\n  position: sticky;\r\n  top: 98px;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 10;\r\n  overflow: hidden;\r\n}\r\n\r\nnav ul {\r\n  overflow-x: auto;\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  white-space: nowrap;\r\n  overflow-x: auto;\r\n  flex-grow: 1;\r\n}\r\n\r\nnav ul::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\nnav ul li {\r\n  display: inline-block;\r\n  padding: 10px;\r\n}\r\n\r\nnav ul li.active {\r\n  background-color: rgb(122,148,90);\r\n  border-radius: 5px;\r\n}\r\n\r\nnav ul li.active a {\r\n  color: white;\r\n}\r\n\r\nnav ul li:hover {\r\n  opacity: .8;\r\n}\r\n\r\nnav ul li a {\r\n  text-decoration: none;\r\n  color: rgb(49, 47, 48);\r\n  font-size: 16px;\r\n}\r\n\r\nnav ul li a.active {\r\n  color: white;\r\n}\r\n\r\n.scroll-button {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  padding: 10px;\r\n  color: rgb(49, 47, 48);\r\n}\r\n\r\n.scroll-button:focus {\r\n  outline: none;\r\n}\r\n\r\n.scroll-button.left {\r\n  margin-right: 10px;\r\n}\r\n\r\n.scroll-button.right {\r\n  margin-left: 10px;\r\n}\r\n\r\n@media screen and (max-width: 910px) {\r\n  nav {\r\n    top: 83px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  nav {\r\n    top: 67px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
